module.exports = __webpack_public_path__ + "img/base_restauration_bouteille.243c889c.svg";